import React, { useState, useEffect } from 'react';
import { css, useTheme } from '@emotion/react';
import type { TimerProps } from 'tsconfig/types';
import { getCountDownTime } from '../../../utils/helperFunction';

export const CmsTimer = ({ contentItem }: TimerProps) => {
  const { headline, endTime, textColor } = contentItem?.fields || {};
  const theme = useTheme();
  const [text, setText] = useState(() => getCountDownTime(endTime));

  useEffect(() => {
    const getTime = (dt: string) => {
      setText(getCountDownTime(dt));
    };
    getTime(endTime);
    const interval = setInterval(() => getTime(endTime), 1000);
    return () => clearInterval(interval);
  }, [endTime]);

  const timerCss = css`
    color: ${textColor};
    ${theme.widgets.CmsTimer?.wrapper};
  `;
  if (text) {
    return (
      <div data-test="widget-timer" css={timerCss}>
        {headline && <span className="timer-headline">{headline}</span>}
        <h2 className="timer-content">{text}</h2>
      </div>
    );
  }
  return null;
};
